import React, { useEffect, useState } from "react";
import { IResponsePost } from "../Interfaces/base/IResponse";
import { useBoolean } from "@fluentui/react-hooks";
import { IPersonaTablets } from "../Interfaces/IEquipo";
import dispositivoServicio from "../services/dispositivo/dispositivoService";
import {
  IDataTableDispositivoAsignado,
  ITablaPersonaEquipo,
} from "../Interfaces/IListaVerificacion";
import dispositivoAsignadoService from "../services/dispositivo/dispositivoAsignadoService";
import { IDispositivoActualizarFechaDevolucion } from "../Interfaces/DispositivoAsignado/IDispositivoAsignado";

export const useEjecutarApis = (id: string | undefined) => {
  const [itemsDispositivo, setItemsDispositivo] = useState<
    IDataTableDispositivoAsignado[]
  >([]);

  const [response, setResponse] = useState<IResponsePost>(null!);
  const [responseActualizarDevolucion, setResponseActualizarDevolucion] =
    useState<IResponsePost>(null!);

  const [isSend, setIsSend] = useState(false);

  const getDataPersonaTablets = () => {
    if (id !== undefined) {
      dispositivoServicio
        .allPersonaTablets(id)
        .then((res) => {
          if (res.status == 200) {
            setItemsDispositivo(res.data);
          }
        })
        .catch((e) => {
          console.log(e);
        });
    }
  };
  const asignarTablets = (data: IPersonaTablets) => {
    setIsSend(true);
    ocultarMensaje();
    dispositivoServicio
      .postPersonaTablets(data)
      .then((res) => {
        if (res.status == 200) {
          getDataPersonaTablets();
          setIsSend(false);
          setResponse(res.data);
        }
      })
      .catch((e: Error) => {
        setResponse({ mensaje: e.message, codigoMensaje: 3 });
        setIsSend(false);
      });
  };
  const actualizarFechaDevolución = (
    data: IDispositivoActualizarFechaDevolucion
  ) => {
    setIsSend(true);
    dispositivoAsignadoService
      .PostActualizarFechaDevolucion(data)
      .then((res) => {
        if (res.status === 200) {
          setResponseActualizarDevolucion(res.data);
          getDataPersonaTablets();
          setIsSend(false);
        }
      })
      .catch((err) => {
        console.log("ests es el error obtenido ", err);
        setIsSend(false);
      });
  };

  const ocultarMensaje = () => {
    setResponse(null!);
    setResponseActualizarDevolucion(null!);
  };

  useEffect(() => {
    getDataPersonaTablets();
  }, []);

  return {
    itemsDispositivo,
    ocultarMensaje,
    response,
    asignarTablets,
    isSend,
    actualizarFechaDevolución,
    responseActualizarDevolucion,
  };
};
